export default __webpack_public_path__ + "static/media/MothBean.5e682d7b.jpeg";